<template>
  <div id="online_service">
    <van-row>
      <van-col span="24">
        <van-col span="24" v-if="has_navigation === 1">
          <van-nav-bar
              left-arrow
              placeholder
              :title="$t('title.online_service')"
              safe-area-inset-top
              @click-left="onClickLeft"
          />
        </van-col>
      </van-col>
      <van-col span="12" offset="1" class="online_service_type">
        <van-cell is-link arrow-direction="down" class="online_service_title-cell" @click="CurrencySellerShow = true">
          <template #default>
            <div v-if="CurrencySellerIndex >= 0">
              <span>
                <img :src="currency_type[CurrencySellerIndex].country_img"/>
                <span>{{ currency_type[CurrencySellerIndex].country_name}}</span> -
              </span>
              {{ currency_type[CurrencySellerIndex].currency_name}}
            </div>
          </template>
        </van-cell>
      </van-col>
      <van-col span="24" class="online_service_list">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('other.there_is_no_more')"
            @load="onLoad"
        >
          <van-cell v-for="(item,i) in list" :key="i">
            <van-col span="24" class="online_service_list_item">
             <van-col span="24">
               <van-col span="4" class="online_service_list_item_i">
                 <van-image
                     width="10vw"
                     height="10vw"
                     round
                     class="online_service_item_avatar"
                     :class="{'online_service-avatar-online': item.is_online == 1}"
                     fit="cover"
                     :src="item.head_image"
                 />
                <div class="online_service-online"> <img :src="item.seller_level_img"/></div>
               </van-col>
               <van-col span="12">
                 <van-col span="24" class="online_service_item_name"> {{ item.nick_name }}  </van-col>
                 <van-col span="24" class="online_service_item_coin">{{ $t('column.deal_of_last_30_days') }} <img src="../assets/img/coin9.png"/> {{ item.diamonds_sum }}</van-col>
               </van-col>
               <van-col span="8" class="online_service_item_private">
                  <span class="online_service_item_private_price"  @click="priceBanner(item)" v-if="item.price_banner_switch == 1">Price</span>
                  <img src="../assets/img/creator_agency_tel.png"  @click="TelMessage(item)"  v-if="item.whats_app_switch == 1"/>
                  <img src="../assets/img/creator_agency_message2.png" v-if="item.quick_message_switch == 1"  @click="privateMessage(item.user_id)"/>
               </van-col>
             </van-col>
              <van-col span="22" offset="1" class="online_service_item_payment">
                {{ $t('column.payment_methood') }}:
                <img :src="t.img" v-for="(t,j) in item.payment_method_img" :key="j"/>
              </van-col>

            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-popup v-model="CurrencySellerShow" position="bottom" :style="{ height: '70%' }" class="online_service_popup"   >
        <van-col span="24" class="currency_type_title"> {{ $t('column.currency_type')}}  </van-col>
        <van-col span="24" class="currency_type_list">
          <van-col span="22" offset="1" class="currency_type_list_item" v-for="(item, index) in currency_type" :key="index" @click="CurrencySellerSelect(index)">
            <van-col span="12" class="currency_type_list_name1"> <img :src="item.country_img"/> {{ item.country_name }} </van-col>
            <van-col span="12" class="currency_type_list_item_content1"> {{ item.currency_name }} <van-icon name="arrow" /></van-col>
          </van-col>
        </van-col>
      </van-popup>
      <van-popup v-model="priceBannerShow" position="bottom" round :style="{ maxHeight: '50%' }">
        <van-image
            width="100%"
            fit="cover"
            :src="price_banner"
        />
      </van-popup>
    </van-row>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from "axios";
import {Dialog, Toast} from "vant";
import SVGA from "svgaplayerweb";

export default {
  data() {
    return {
      CurrencySellerIndex: -1,
      CurrencySellerShow: false,
      currency_type: [],
      list: [],
      finished: false,
      loading: false,
      page: 1,
      has_navigation: 1,
      priceBannerShow: false,
      price_banner: '',
    }
  },
  created () {
    this.has_navigation = this.$route.query.has_navigation && this.$route.query.has_navigation != 1 ? 0 : 1
    console.log(this.has_navigation)
    if (this.has_navigation === 0){
        document.title = this.$t('title.online_service')
    }
    this.get_currency_type_list()
    
    this.convert()
  },
  methods: {
    CurrencySellerSelect(index){
      this.CurrencySellerIndex = index
      this.page = 1
      this.finished = false
      this.convert()
      this.CurrencySellerShow = false
    },
    get_currency_type_list() {
      const token = this.$route.query.token
      this.loading = true
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_currency_type_list", {
        params : {
          token: token
        }
      }).then(res =>{
        // 加载状态结束
        this.loading = false
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.currency_type = res.data.data.list
        this.CurrencySellerShow = true
      })
    },
    priceBanner(item) {
      // banner弹框展示 item.price_banner
      if (item.price_banner) {
        this.price_banner = item.price_banner
        this.priceBannerShow = true
      }
    },
    TelMessage(item) {
      // 拦截跳转联系方式WhatsApp
      window.location.href="live://live?action=JumpUserWhatsApp&tel=" + item.whats_country_code + item.whats_app
    },
    privateMessage(id) {
      // 拦截跳转私信：先发送一条消息，再跳转私信
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=send_quick_message", {
        params : {
          token: token,
          touid: id
        }
      }).then(res =>{
        // 加载状态结束; 再跳转私信
         window.location.href="live://live?action=JumpUserPrivateMessage&id=" + id
      })
    },
    onLoad() {
      // 异步更新数据
      if (this.page > 1) {
        this.convert()
      }
    },
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    convert() {
      const token = this.$route.query.token
      const currency_type_id = this.CurrencySellerIndex >= 0 ? this.currency_type[this.CurrencySellerIndex].currency_type_id : ''
      this.loading = true
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_coin_seller_list", {
        params : {
          token: token,
          currency_type_id: currency_type_id,
          page: this.page,
        }
      }).then(res =>{
        // 加载状态结束
        this.loading = false
        if (res.data.status === 0) {
          Toast(res.data.error)
          this.finished = true
          return false
        }
        if (this.page == 1) {
          this.list = []
          this.finished = false
        }
        for(let i = 0; i< res.data.data.list.length; i ++) {
          this.list.push(res.data.data.list[i])
        }
        // 数据全部加载完成
        if (res.data.data.list.length <= 0) {
          this.finished = true
        }
        this.page ++
      })
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/online_service.vue